import { FC, useContext, useEffect, useState } from "react";
//RIGHT
import blueExclamationCrownToRight from "../../../assets/icons/dilemmaOwnerCrowns/blueExclamationCrownToRight.svg";
import greenExclamationCrownToRight from "../../../assets/icons/dilemmaOwnerCrowns/greenExclamationCrownToRight.svg";
import yellowExclamationCrownToRight from "../../../assets/icons/dilemmaOwnerCrowns/yellowExclamationCrownToRight.svg";
import pinkExclamationCrownToRight from "../../../assets/icons/dilemmaOwnerCrowns/pinkExclamationCrownToRight.svg";

//RIGHT
import blueQuestionCrownToRight from "../../../assets/icons/dilemmaOwnerCrowns/blueQuestionCrownToRight.svg";
import greenQuestionCrownToRight from "../../../assets/icons/dilemmaOwnerCrowns/greenQuestionCrownToRight.svg";
import yellowQuestionCrownToRight from "../../../assets/icons/dilemmaOwnerCrowns/yellowQuestionCrownToRight.svg";
import pinkQuestionCrownToRight from "../../../assets/icons/dilemmaOwnerCrowns/pinkQuestionCrownToRight.svg";

//RIGHT
import blueSquareCrownToRight from "../../../assets/icons/dilemmaOwnerCrowns/blueSquareCrownToRight.svg";
import greenSquareCrownToRight from "../../../assets/icons/dilemmaOwnerCrowns/greenSquareCrownToRight.svg";
import yellowSquareCrownToRight from "../../../assets/icons/dilemmaOwnerCrowns/yellowSquareCrownToRight.svg";
import pinkSquareCrownToRight from "../../../assets/icons/dilemmaOwnerCrowns/pinkSquareCrownToRight.svg";
import { TeamContext } from "../../../context";
import { Phase } from "../../../util/enums";


interface IDilemmaOwnerFirstPersonViewCrown {
    playerColor: string | undefined;
}

const DilemmaOwnerFirstPersonViewCrown: FC<IDilemmaOwnerFirstPersonViewCrown> = (props) => {
    const { playerColor } = props;
    const { game } = useContext(TeamContext);
    const [crownType, setCrownType] = useState<string>("initial");
    let crownBasedOnUserColor: any;

    useEffect( () => {
        if(game?.phase === Phase.ACTION_CARD){
            setCrownType("action");
        }
        if(game?.phase === Phase.QUESTION_CARD || game?.phase === Phase.CHOOSE_SOLUTION || game?.phase === Phase.RENDER_SPIN_WHEEL || game?.phase === Phase.NINE){
            setCrownType("question")
        }
        if(game?.phase === Phase.CHOOSING_SOLUTION_CARDS || game?.phase === Phase.PICK_DILEMMA){
            setCrownType("initial")
        }
    }, [game])

    switch (playerColor) {
        case "pink": {
            if (crownType === "initial")
                crownBasedOnUserColor = pinkSquareCrownToRight;

            if (crownType === "action")
                crownBasedOnUserColor = pinkExclamationCrownToRight;

            if (crownType === "question")
                crownBasedOnUserColor = pinkQuestionCrownToRight;
            break;
        }
        case "blue": {
            if (crownType === "initial")
                crownBasedOnUserColor = blueSquareCrownToRight;

            if (crownType === "action")
                crownBasedOnUserColor = blueExclamationCrownToRight;

            if (crownType === "question")
                crownBasedOnUserColor = blueQuestionCrownToRight;
            break;
        }
        case "green": {
            if (crownType === "initial")
                crownBasedOnUserColor = greenSquareCrownToRight;

            if (crownType === "action")
                crownBasedOnUserColor = greenExclamationCrownToRight;

            if (crownType === "question")
                crownBasedOnUserColor = greenQuestionCrownToRight;
            break;
        }
        case "yellow": {
            if (crownType === "initial")
                crownBasedOnUserColor = yellowSquareCrownToRight;

            if (crownType === "action")
                crownBasedOnUserColor = yellowExclamationCrownToRight;

            if (crownType === "question")
                crownBasedOnUserColor = yellowQuestionCrownToRight;
            break;
        }
    }

    return (
        <div className={`crown_wrapper_right_side`}>
            <img
                className="crown_image_left"
                src={crownBasedOnUserColor}
                alt="Profile Icon"
            />
        </div>
    )
}

export default DilemmaOwnerFirstPersonViewCrown;